import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'
export function getPagesList (query) { //广告页面列表
    return fetchGet('/gateway/v1/ad-pages', query)
}
export function getPageDetail (id) { //广告页面详情
    return fetchGet('/gateway/v1/ad-page/'+id)
}

export function changePage (id, params) { //修改广告页面
    return fetchPut('/gateway/v1/ad-page/'+id, params)
}

export function delPage(id) { //删除广告页面
    return fetchDelete('/gateway/v1/ad-page/'+id)
}
export function createPage (params) { //创建广告页面
    return fetchPost('/gateway/v1/ad-page', params)
}


export function getAdPositionList (query) { //广告位位列表
    return fetchGet('/gateway/v1/ad-positions', query)
}
export function createPosition (params) { //创建广告位
    return fetchPost('/gateway/v1/ad-position', params)
}
export function getPositionDetail (id) { //广告位详情
    return fetchGet('/gateway/v1/ad-position/'+id)
}

export function changePosition (id, params) { //修改广告位
    return fetchPut('/gateway/v1/ad-position/'+id, params)
}

export function delPosition(id) { //删除广告位
    return fetchDelete('/gateway/v1/ad-position/'+id)
}

/* 广告文件上传 */
export function uploadFileAd (tosId,params) {
    return fetchPost('/gateway/v1/tos/'+tosId+'/files-origin', params, {
        'Content-Type': 'multipart/form-data'
    })
}

export function createAd (params) { //创建广告
    return fetchPost('/gateway/v1/ad', params)
}

export function getAdsList (query) { //广告列表
    return fetchGet('/gateway/v1/ads', query)
}

export function changeOnline (id,params) { //上下线
    return fetchPut('/gateway/v1/ad/'+id+'/online',params)
}
export function delAd(id,params) { //删除广告
    return fetchDelete('/gateway/v1/ad/'+id,params)
}
export function editAd(id,params) { //修改广告位
    return fetchPut('/gateway/v1/ad/'+id,params)
}